module.exports = __webpack_public_path__ + "img/psd.a3189f92.png";